import React from "react";
import {StatusPopupType} from "../../../com/statusPopup/StatusPopup";

interface Settings {
    typeStatus?: number,
    title?: string,
    subTitle?: string,
    messages?: any;
    modalName?: string;
    confirmOnClick?: {
        onHardDeleteClick?: React.MouseEventHandler<HTMLButtonElement>;
        onSoftDeleteClick?: React.MouseEventHandler<HTMLButtonElement>;
        onUploadImage?: React.MouseEventHandler<HTMLButtonElement>;
        deletePromosItemsFromFlyer?: (e: boolean) => void;
        deleteFramesFromFlyer?: (e: boolean) => void;
        uploadPdfFileToFlipbook?: React.MouseEventHandler<HTMLButtonElement>;
    };
}


export const getSettingsForPopup = (props: Settings) => {

    const settings: Settings = {
        typeStatus: 0,
        title: '',
        subTitle: '',
        messages: [],
        modalName: props.modalName,
        confirmOnClick: {}
    };
    switch (props.modalName) {
        case "error":
            settings.typeStatus = StatusPopupType.INFO;
            settings.title = 'INFO';
            settings.subTitle = 'Oops';
            settings.messages = props.messages;
            break;
        case "success":
            settings.typeStatus = StatusPopupType.CONFIRM;
            settings.title = 'SUCCESS';
            settings.subTitle = '';
            settings.messages = props.messages;
            break;
        case "successfullyUpload":
            settings.typeStatus = StatusPopupType.CONFIRM;
            settings.title = 'SUCCESS';
            settings.subTitle = '';
            settings.messages = props.messages;
            break;
        case "qualificationForFrameWithWarning":
            settings.typeStatus = StatusPopupType.INFO;
            settings.title = 'NOTE';
            settings.subTitle = '';
            settings.messages = props.messages;
            break;
        case "successfullyUploadWithSomeErrors":
            settings.typeStatus = StatusPopupType.INFO;
            settings.title = 'WARNING';
            settings.subTitle = '';
            settings.messages = props.messages;
            break;
        case "successfullyUploadWithSomePromosAndItemsErrors":
            settings.typeStatus = StatusPopupType.INFO;
            settings.title = 'UPLOAD INCOMPLETE';
            settings.subTitle = '';
            settings.messages = props.messages;
            break;
        case "confirmHardDelete":
            settings.typeStatus = StatusPopupType.CONFIRM;
            settings.title = 'Confirm';
            settings.subTitle = '';
            settings.messages = [];
            settings.confirmOnClick = {
                onHardDeleteClick: props.confirmOnClick?.onHardDeleteClick
            }
            break;
        case "confirmSoftOrHardDelete":
            settings.typeStatus = StatusPopupType.CONFIRM;
            settings.title = 'Confirm';
            settings.subTitle = '';
            settings.messages = [];
            settings.confirmOnClick = {
                onHardDeleteClick: props.confirmOnClick?.onHardDeleteClick,
                onSoftDeleteClick: props.confirmOnClick?.onSoftDeleteClick
            }
            break;
        case "uploadImageToPage":
            settings.typeStatus = StatusPopupType.CONFIRM;
            settings.title = 'Confirm';
            settings.subTitle = '';
            settings.messages = [];
            settings.confirmOnClick = {
                onUploadImage: props.confirmOnClick?.onUploadImage,
            }
            break;
        case "uploadImagesToPageNotEqualSelectedPages":
            settings.typeStatus = StatusPopupType.INFO;
            settings.title = 'INFO';
            settings.subTitle = '';
            settings.messages = ['The number of selected pages must be equal to the number of pages to upload.'];
            break;
        case "moreThanAllowed":
            settings.typeStatus = StatusPopupType.INFO;
            settings.title = 'INFO';
            settings.subTitle = '';
            settings.messages = ['Pages in Flyer can only be between 1-1000.'];
            break;
        case "checkoutAccountSettingNotExist":
            settings.typeStatus = StatusPopupType.INFO;
            settings.title = 'INFO';
            settings.subTitle = '';
            settings.messages = ['First set the Checkout URL Settings for the Account in Settings menu.'];
            break;
        case "confirmHardDeleteFlyer":
            settings.typeStatus = StatusPopupType.CONFIRM;
            settings.title = 'Confirm';
            settings.subTitle = '';
            settings.messages = [];
            settings.confirmOnClick = {
                onHardDeleteClick: props.confirmOnClick?.onHardDeleteClick
            }
            break;
        case "confirmHardDeleteFlipbook":
            settings.typeStatus = StatusPopupType.CONFIRM;
            settings.title = 'Confirm';
            settings.subTitle = '';
            settings.messages = [];
            settings.confirmOnClick = {
                onHardDeleteClick: props.confirmOnClick?.onHardDeleteClick
            }
            break;
        case "deletePromosFromFlyer":
        case "deleteItemsFromFlyer":
            settings.typeStatus = StatusPopupType.CONFIRM;
            settings.title = 'Confirm';
            settings.subTitle = '';
            settings.messages = [];
            settings.confirmOnClick = {
                deletePromosItemsFromFlyer: props.confirmOnClick?.deletePromosItemsFromFlyer
            }
            break;
        case "deleteFramesFromFlyer":
            settings.typeStatus = StatusPopupType.CONFIRM;
            settings.title = 'Confirm';
            settings.subTitle = '';
            settings.messages = [];
            settings.confirmOnClick = {
                deleteFramesFromFlyer: props.confirmOnClick?.deleteFramesFromFlyer
            }
            break;
        case "saveBeforeCloseInfo":
            settings.typeStatus = StatusPopupType.INFO;
            settings.title = 'NOTE';
            settings.subTitle = '';
            settings.messages = ['Save edits before exiting screen.'];
            break;
        case "uploadPdfFileToFlipbook":
            settings.typeStatus = StatusPopupType.CONFIRM;
            settings.title = 'Confirm';
            settings.subTitle = '';
            settings.messages = [];
            settings.confirmOnClick = {
                uploadPdfFileToFlipbook: props.confirmOnClick?.uploadPdfFileToFlipbook,
            }
            break;
    }

    return settings;
}
